// extracted by mini-css-extract-plugin
export default {"cls1":"BulkFollowSuggestion-cls1__JP","cls2":"BulkFollowSuggestion-cls2_W9k BulkFollowSuggestion-cls1__JP"};